/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 9.3.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Structured address components.
 * @export
 * @interface AddressComponentsV2
 */
export interface AddressComponentsV2 {
  /**
   * The cross street address component (rarely used).
   * @type {string}
   * @memberof AddressComponentsV2
   */
  crossStreet?: string | null;
  /**
   * The house / building number.
   *
   * Note that, despite the name, this is not strictly numeric.
   * Values such as 30-1 and 11A may be valid building/house numbers in some areas.
   * @type {string}
   * @memberof AddressComponentsV2
   */
  number?: string | null;
  /**
   * The postal code.
   * @type {string}
   * @memberof AddressComponentsV2
   */
  postalCode?: string | null;
  /**
   * The street component of the address.
   * @type {string}
   * @memberof AddressComponentsV2
   */
  street?: string | null;
  /**
   * The unit number (where available).
   * @type {string}
   * @memberof AddressComponentsV2
   */
  unit?: string | null;
}

/**
 * Check if a given object implements the AddressComponentsV2 interface.
 */
export function instanceOfAddressComponentsV2(
  value: object,
): value is AddressComponentsV2 {
  return true;
}

export function AddressComponentsV2FromJSON(json: any): AddressComponentsV2 {
  return AddressComponentsV2FromJSONTyped(json, false);
}

export function AddressComponentsV2FromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AddressComponentsV2 {
  if (json == null) {
    return json;
  }
  return {
    crossStreet:
      json["cross_street"] == null ? undefined : json["cross_street"],
    number: json["number"] == null ? undefined : json["number"],
    postalCode: json["postal_code"] == null ? undefined : json["postal_code"],
    street: json["street"] == null ? undefined : json["street"],
    unit: json["unit"] == null ? undefined : json["unit"],
  };
}

export function AddressComponentsV2ToJSON(json: any): AddressComponentsV2 {
  return AddressComponentsV2ToJSONTyped(json, false);
}

export function AddressComponentsV2ToJSONTyped(
  value?: AddressComponentsV2 | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cross_street: value["crossStreet"],
    number: value["number"],
    postal_code: value["postalCode"],
    street: value["street"],
    unit: value["unit"],
  };
}
